export const withUpdateInPath =
	<T extends (value: any, path: any) => void>(fn: T, subpath: string) =>
	(value: Parameters<T>[0], path?: Parameters<T>[1]) =>
		fn(value, path ? [subpath, path].join('.') : subpath);

export const toInt = (str: string) =>
	typeof str === 'string' ? Number.parseInt(str, 10) : 0;
export const intToPx = (num: number) => `${num}px`;
